import { StyledSwitch } from "./styles";

const Switch = ({ ...props }) => {
  return <StyledSwitch {...props} />;
};

export default Switch;
